// Auth token and device identifier
export const AUTH_TOKEN = "aToken";
export const DEVICE_IDENTIFIER = "deviceidentifier";

// Login
export const ACCOUNT_NUMBER = "accountNumber";
export const USER_ID = "userId";

// Redux Store state
export const PERSIST_ROOT_KEY = "persist:root";

// Outlet Online Status
export const OUTLET_ONLINE_STATUS = "outletOnlineStatus";
export const BRANCH_OUTLET_STATUS = 'branchOutletStatus';

export const APP_SOURCE = "appSource";
export const APP_SOURCE_TYPES = { POS: "pos", RMP: "rmp " };

//DYNAMIC REPORTS
export const DONT_SHOW_FAQ = "dont_show_faq";

export const LOCALSTORAGE_KEYS = {
  SUPPORT_ID_TOKEN: "supportIdToken",
  SUPPORT_SIGN: "supportSign",
  IS_SUPPORT_LOGIN: "isSupportLogin",

  CHAT_MESSAGES: "CHAT_MESSAGES",
  CHATBOT_SESSION_ID: "CHATBOT_SESSION_ID",
  NW_APP_VERSION: "nwAppVersion",
  ORACLE_VERSION: "oracleVersion",

  HORIZON_LEAD_MODAL_SEEN: "horizon_lead_modal_seen",
} as const;

//GOOGLE ANALYTICS
export const feature_request = (event: string) => {
  return 'request-feature-' + event;
}